import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { EbUser } from '../../classes/user';
import { EbChat } from '../../classes/chat';
import { Statique } from "../../utils/statique";
import { ChatService } from '../../services/chat.service';

@Component({
	selector: 'app-chat-panel',
	templateUrl: './chat-panel.component.html',
	styleUrls: ['./chat-panel.component.css']
})
export class ChatPanelComponent implements OnInit, OnChanges {

	statique = Statique;
	
	@Input() public dataSource: string;
	@Input() public dataInsertion: string;
	@Input() public module: number;
	@Input() public idChatComponent?: number;
	@Input() public idFiche: number;
	@Input() public user: EbUser;
	
	ebChat : EbChat = new EbChat();
	listChat = new Array<EbChat>();

	constructor(private chatService : ChatService) { }
	
	ngOnInit() {
		// faut envoyer le numero de la demande
		// datasource un string format String controller statique (comme Statique.controllerStatiqueListe) + "/listChat?demande="+demande (ou n'importe qu"elle data a enovyer)
		//
	}

	ngOnChanges(){

		this.chatService.getListChat(this.dataSource + "?module=" + this.module + "&idFiche=" + this.idFiche + "&idChatComponent=" + this.idChatComponent).subscribe((data) => {
			this.listChat = data;
		});
	}

	sendChat2(){

		this.ebChat.userName = this.user.nom + " " + this.user.prenom;
		this.ebChat.xEbUser = this.user.ebUserNum;
		this.ebChat.module = this.module;
		this.ebChat.idFiche = this.idFiche;
		this.ebChat.idChatComponent = this.idChatComponent;
		this.ebChat.text="old_status => new_status";
		this.chatService.addChat(this.dataInsertion, this.ebChat).subscribe((data) => {
			this.listChat.push(data);
			this.ebChat = new EbChat();
		});

	}

	sendChat(){
		if(!this.ebChat.text || this.ebChat.text.trim().length <= 0)
			return;
		
		this.ebChat.userName = this.user.nom + " " + this.user.prenom;
		this.ebChat.xEbUser = this.user.ebUserNum;
		this.ebChat.module = this.module;
		this.ebChat.idFiche = this.idFiche;
		this.ebChat.idChatComponent = this.idChatComponent;

		this.chatService.addChat(this.dataInsertion, this.ebChat).subscribe((data) => {
			this.listChat.push(data);
			this.ebChat = new EbChat();
		});

	}
}



// WEBPACK FOOTER //
// ./src/app/shared/chat-panel/chat-panel.component.ts